export const TEXT_MANAGE_ACCOUNT = 'Account Details'
